import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime, IonRefresher, IonRefresherContent } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect} from 'react';

import { ViewOrderListModal } from './Modal_OrderList';
import { ViewOrderListModal_InStore } from './Modal_OrderList_InStore';
import { ViewOrderListModal_History } from './Modal_OrderList_History';
import { Retail_Homepage } from '../../../zPublic/components/Homepage_retail';

import {DateRange} from '../../../zInternal_Features/merchant/components/DateRange'

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { PushNotifiPushNotificationSchema, PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';
import { Toast } from "@capacitor/toast";


export function Tab_Operations(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    //alert('In CheckIn_CheckOutSlides')
    //alert(authenticatedMerchent_context.acctID);
    //alert(authenticatedMerchent_context.accessRights);
    //alert(authenticatedMerchent_context.accessRights[0]);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate()-7)));
    let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate()+7)));

    let [startDate_display, setStartDate_display] = useState(false);
    let [endDate_display, setEndDate_display] = useState(false);

    let [numOfOrdersPendingFufilment, setNumOfOrdersPendingFufilment] = useState(0);
    let [numOfOrdersPendingFufilment_inStore, setNumOfOrdersPendingFufilment_inStore] = useState(0);

    let [searchGuestData, setSearchGuestData] = useState(null);

    let [showNumOfOrdersPendingFufilmentModal, setShowNumOfOrdersPendingFufilmentModal] = useState(false);
    let [showNumOfOrdersPendingFufilmentModal_retail, setShowNumOfOrdersPendingFufilmentModal_retail] = useState(false);
    let [showNumOfOrdersPendingFufilmentModal_orderHistory, setShowNumOfOrdersPendingFufilmentModal_orderHistory] = useState(false);

    let [viewMerchantList_retailServices, setViewMerchantList_retailServices] = useState([]);

    let [companyID, setCompanyID] = useState(null);
    let [companySchema, setCompanySchema] = useState(null);
    let [companyName, setCompanyName] = useState(null);
    let [companyAddressNumber, setCompanyAddressNumber] = useState(false);
    let [companyStreetName, setCompanyStreetName] = useState(false);
    let [companyCity, setCompanyCity] = useState(false);
    let [companyCityDistrict, setCompanyCityDistrict] = useState(false);
    let [companyPhoneNumber, setCompanyPhoneNumber] = useState(false);
    let [companyEmail, setCompanyEmail] = useState(false);
    let [customerRating, setCustomerRating] = useState('0.00000');
    let [companyLatitude, setCompanyLatitude] = useState(null);
    let [companyLongitude, setCompanyLongitude] = useState(null);
    let [retailHomepageModal, setRetailHomepageModal] = useState(false);
    let [mtnCompanyPhoneNumber, setMtnCompanyPhoneNumber] = useState(false);

    let [notifications, setnotifications] = useState([]);
    
    function searchGuestDataHandler(e) {
        
        setSearchGuestData(e.target.value);
    }



    function reloadDates(event)
    {

         //alert('In Tab Overview UseEffect');
        //alert(authenticatedMerchent_context.accessRights[0]);
        // alert(JSON.parse(authenticatedMerchent_context.feature).employeeHR);
        // alert(JSON.parse(authenticatedMerchent_context.feature).jobs);

        //alert(startDate);
        //alert(endDate);

        let formData = new FormData();
        let tracker = 0;

        //formData.append('Tracker', 74001);
        /*formData.append('user', acctID);
        formData.append('xStartDateRange', startDate.toISOString().substr(0, 10));
        formData.append('xEndDateRange', endDate.toISOString().substr(0, 10));


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }*/

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: "74100_retail",
                user: acctID,
                xStartDateRange: event[0],
                xEndDateRange: event[1],
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //let rows = res.toString().split('~~~');
            //let rowLength = rows.length;

                //for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                //{
                    //let cols = rows[rownum].split('|');


                        let cols = res.toString().split('|');

                        setNumOfOrdersPendingFufilment(cols[0]);
                        setNumOfOrdersPendingFufilment_inStore(cols[1]);

                    
                    

                       
                    authenticatedMerchent_context.changeStartDateRange(event[0]);
                    authenticatedMerchent_context.changeEndDateRange(event[1]);

                    setStartDate(new Date(event[0]));
                    setEndDate(new Date(event[1]));

            })

    }




    function getMerchantRetailList()
    {        

        setViewMerchantList_retailServices([]);

            const requestOptions = {
                method:'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                 },
                body: JSON.stringify({
                    Tracker: "0002_retail_specific",
                    user: acctID,
                    sessionID: sessionID,

    
                })            }
    
            //alert('In ghanaverifiedApp - HotelList UseEffect');
            let cols_spit;
            let cols;
            let cols_1;

            fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');
                for(let rowNum = 0; rowNum < rows.length - 1; ++rowNum)
                {
                 
                    cols_spit = rows[rowNum].split('#');
                    cols = cols_spit[0].split('|');
                    cols_1 = cols_spit[1].split('|');

                    //alert("Splitting Columns");
                    //alert(cols_spit);
                    //alert(cols);
                    //alert(cols[13]);


                    setViewMerchantList_retailServices((prevViewMerchantList_hotels) => {
                        return prevViewMerchantList_hotels.concat({
                            companyAcctID: cols[0],
                            companyName: cols[1],
                            companyAddressNumber: cols[2],
                            streetName: cols[3],
                            city: cols[4],
                            cityDistrict: cols[5],
                            companyPhoneNumber: cols[6],
                            companyEmail: cols[7],
                            companyImage: cols[8],
                            companySchema: cols[9],
                            customerRating: cols[10],
                            latitude: cols[11],
                            longitude: cols[12],
                            mtnCompanyPhoneNumber: cols[13],
                            merchantID: cols_1[0], 
                            merchantName: cols_1[1],
                            merchantMomoNumber: cols_1[2],
                            merchantUpload_ghanaID: cols_1[3],
                            merchantUpload_businessRegistrationID: cols_1[4],
                            merchantAddress: cols_1[5],
                            latitude: cols_1[6],
                            longitude: cols_1[7],
                            merchantUpload_companyMainImage: cols_1[8],
                            companyShowcase: cols_1[9],
                            date_logged: cols_1[10],
                            onboardingStatus: cols_1[11],
                        })

                        
                    });


                }

                setCompanyID(cols[0]);
                setCompanySchema(cols[9]);
                setCompanyName(cols[1]);
                setCompanyAddressNumber(cols[2]);
                setCompanyStreetName(cols[3]);
                setCompanyCity(cols[4]);
                setCompanyCityDistrict(cols[5]);
                setCompanyEmail(cols[7]);
                setCompanyPhoneNumber(cols[6]);
                setCustomerRating(cols[10]);
                setCompanyLatitude(cols[11]);
                setCompanyLongitude(cols[12]);
                setMtnCompanyPhoneNumber(cols[13]);

                setRetailHomepageModal(true);

            })
    };

    function handle_retailHomepageModal()
    {
        getMerchantRetailList();
    }

    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
            event.detail.complete();   // Stop the spinner
            window.location.reload();  // Reload the entire app
        }, 500);
    }

    useEffect(() => {

        reloadDates([startDate.toISOString().substr(0, 10), endDate.toISOString().substr(0, 10)]);

   }, []);
    //alert('In CheckInCheckOut');
    //alert(notifications);
    //alert(notifications.length);
    //alert(authenticatedMerchent_context.accessRights[0]);


    return (
        <React.Fragment>

        {notifications.length !== 0 &&
        <IonList>
            {notifications.map((notif) =>
                <IonItem key={notif.id}>
                    <IonLabel>
                        <IonText>
                            <h3 className="notif-title">{notif.title}</h3>
                        </IonText>
                        <p>{notif.body}</p>
                    </IonLabel>
                </IonItem>
            )}
            </IonList>}


        <IonContent className='appContent'>
        <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
            <IonRefresherContent
            pullingText="Pull to refresh the app"
            refreshingSpinner="circles"
            refreshingText="Refreshing app..."
            />
        </IonRefresher>
        <IonItem>
            <IonGrid>
                    <DateRange setDate={(e) => reloadDates(e)} data={{
                    startDate: startDate, 
                    endDate: endDate
                    }}></DateRange>
            </IonGrid>
        </IonItem>
            <IonGrid >
                <IonRow>
                    <IonCol size='6'>
                        <h3>Online</h3>
                        <p > {numOfOrdersPendingFufilment} </p>
                        <IonButton onClick={() => setShowNumOfOrdersPendingFufilmentModal(true)}> View </IonButton>
                    </IonCol>
                    <IonCol size='6'>
                        <h3>In-Store</h3>
                        <p > {numOfOrdersPendingFufilment_inStore} </p>
                        <IonButton onClick={() => setShowNumOfOrdersPendingFufilmentModal_retail(true)}> View </IonButton>
                    </IonCol>
                </IonRow>
                {/*<IonRow>
                    <IonCol size='12'>
                        <h3>Order History</h3>
                        <p > {0} </p>
                        <IonButton onClick={() => setShowNumOfOrdersPendingFufilmentModal_orderHistory(true)}> View </IonButton>
                    </IonCol>
                </IonRow>*/}
                <IonRow>
                    <IonCol size='12'>
                        <IonButton onClick={() => handle_retailHomepageModal(true)}> CREATE ORDER </IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>


            {showNumOfOrdersPendingFufilmentModal == true && <ViewOrderListModal openModal={ showNumOfOrdersPendingFufilmentModal } closeModal={() => setShowNumOfOrdersPendingFufilmentModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></ViewOrderListModal>}
            {showNumOfOrdersPendingFufilmentModal_retail == true && <ViewOrderListModal_InStore openModal={ showNumOfOrdersPendingFufilmentModal_retail} closeModal={() => setShowNumOfOrdersPendingFufilmentModal_retail(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></ViewOrderListModal_InStore>}
            {showNumOfOrdersPendingFufilmentModal_orderHistory == true && <ViewOrderListModal_History openModal={ showNumOfOrdersPendingFufilmentModal_orderHistory } closeModal={() => setShowNumOfOrdersPendingFufilmentModal_orderHistory(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></ViewOrderListModal_History>}


            {retailHomepageModal == true && <Retail_Homepage openModal={retailHomepageModal} closeModal={() => setRetailHomepageModal(false)} data={{
                    status: "create_order_internal",
                    companyId: companyID, 
                    companySchema: companySchema, 
                    companyName: companyName,
                    companyAddressNumber: companyAddressNumber,
                    companyStreetName: companyStreetName,
                    companyCity: companyCity,
                    companyCityDistrict: companyCityDistrict,
                    companyEmail: companyEmail,
                    companyPhoneNumber: companyPhoneNumber,
                    customerRating: customerRating,
                    mtnCompanyPhoneNumber: mtnCompanyPhoneNumber,
                    }}></Retail_Homepage>}


        </IonContent>
        </React.Fragment>
    )
    //}   
}